import { Injectable, inject } from '@angular/core';

import { Odds, OddsFormat } from '@bpos';
import { NativePrice } from '@frontend/sports/odds/feature/native-price';
import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { UserOddsFormatSettingsService } from '@frontend/sports/user/feature';
import { Decimal } from 'decimal.js';

@Injectable({ providedIn: 'root' })
export class OddsFormatConverterService {
    private readonly userOddsFormatSettingsService = inject(UserOddsFormatSettingsService);

    /**
     * @param  price - The native price object.
     * @returns  - the decimal value of the the current odds format calculated from the provided native price
     */
    getOddsByOddsFormat(price: NativePrice): Decimal {
        switch (this.userOddsFormatSettingsService.oddsFormat) {
            case OddsDisplayFormat.UK:
                return price.fraction;
            case OddsDisplayFormat.US:
                return NativePrice.americanOddsToDecimalOdds(price.americanOdds);
            default:
                return price.odds;
        }
    }

    /**
     * @param  price - The native price object.
     * @returns  - the decimal value of the the current odds format calculated from the provided native price
     */
    getCalculatedOddsByFormat(price: NativePrice): Decimal {
        if (this.userOddsFormatSettingsService.oddsFormat === OddsDisplayFormat.US && price.americanOddsCalculation !== undefined) {
            return new Decimal(price.americanOddsCalculation);
        }

        return this.getOddsByOddsFormat(price);
    }

    getEmptyBposOdds(): Odds {
        return {
            european: 0,
            british: { numerator: 0, denominator: 0 },
            american: 0,
            oddsFormat: this.getBposOddsFormat(),
        };
    }

    private getBposOddsFormat(): OddsFormat {
        switch (this.userOddsFormatSettingsService.oddsFormat) {
            case OddsDisplayFormat.UK:
                return OddsFormat.British;
            case OddsDisplayFormat.US:
                return OddsFormat.American;
            default:
                return OddsFormat.European;
        }
    }
}
